<template>
  <teleport to="body">
    <pdl-drawer id="comparable-value-modal" size="23rem" show-close :is-open="isDrawerOpen" @close="handleClose">
      <template #content>
        <div class="space-y-8">
          <pdl-heading size="md" qaid="pricing-drawer-header">
            {{ $t('text.msrp') }}
          </pdl-heading>
          <p class="mt-3 text-sm font-normal">
            {{ $t('text.buyingzone.retailerPrice.details.message') }}
          </p>
        </div>
      </template>
    </pdl-drawer>
  </teleport>
</template>

<script>
import {PdlDrawer} from '@pedal/pdl-drawer';
import {PdlHeading} from '@pedal/pdl-section-header';
export default {
  components: {PdlDrawer, PdlHeading},
  props: {
    isDrawerOpen: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.pdl-drawer {
  z-index: 9997;

  @media (min-width: 640px) {
    top: var(--header-height);
    height: calc(100% - var(--header-height));
  }
}
</style>
